export default {
  // 邮件配置
  MAIL_PROPERTIES: "Mail Properties",
  MAIL_PROPERTIES_CREATE: "Create Mail Properties",
  MAIL_PROPERTIES_CREATE_SUCCESS: "Create Mail Properties Successful.",
  MAIL_PROPERTIES_UPDATE: "Update Mail Properties",
  MAIL_PROPERTIES_UPDATE_SUCCESS: "Update Mail Properties Successful.",
  MAIL_PROPERTIES_USERNAME: "Username",
  MAIL_PROPERTIES_USERNAME_REQUIRED: "Mail properties username required",
  MAIL_PROPERTIES_PASSWORD: "Password",
  MAIL_PROPERTIES_MAIL_HOST: "Host",
  MAIL_PROPERTIES_MAIL_HOST_REQUIRED: "Mail properties host required",
  MAIL_PROPERTIES_MAIL_FROM: "Mail From",
  MAIL_PROPERTIES_MAIL_FROM_REQUIRED: "Mail properties mail from required",
  MAIL_PROPERTIES_MAIL_PORT: "Port",
  MAIL_PROPERTIES_MAIL_PORT_REQUIRED: "Mail properties port required",
  MAIL_PROPERTIES_SMTP_AUTH: "Auth",
  MAIL_PROPERTIES_SMTP_SSL: "SSL",
  
  // 邮件模版
  MAIL_TEMPLATE: "Mail Template",
  MAIL_TEMPLATE_CREATE: "Create Mail Template",
  MAIL_TEMPLATE_CREATE_SUCCESS: "Create Mail Template Successful.",
  MAIL_TEMPLATE_UPDATE: "Update Mail Template",
  MAIL_TEMPLATE_UPDATE_SUCCESS: "Update Mail Template Successful.",
  MAIL_TEMPLATE_CODE: "Code",
  MAIL_TEMPLATE_CODE_REQUIRED: "Mail template code is required",
  MAIL_TEMPLATE_NAME: "Name",
  MAIL_TEMPLATE_NAME_REQUIRED: "Mail template name is required",
  MAIL_TEMPLATE_MAIL_FROM: "From",
  MAIL_TEMPLATE_MAIL_FROM_REQUIRED: "Mail template from is required",
  MAIL_TEMPLATE_MAIL_TO: "To",
  MAIL_TEMPLATE_MAIL_TO_REQUIRED: "Mail template mail to is required",
  MAIL_TEMPLATE_MAIL_CC: "CC",
  MAIL_TEMPLATE_MAIL_BCC: "BCC",
  MAIL_TEMPLATE_MAIL_TITLE: "Title",
  MAIL_TEMPLATE_MAIL_CONTENT: "Content",
  MAIL_TEMPLATE_VERIFY_CODE_SEND_SUCCESS: "Send verify code success",
};
